export const languages = [
  {
    label: 'Español',
    value: 'es'
  },
  {
    label: 'English',
    value: 'en'
  }
]

export const i18n = {
  es: {
    WizardLayout__step: 'Paso',
    WizardLayout__stepOf: 'de',
    RegisterWizardWelcome__title: 'Te damos la bienvenida Mercado Público',
    RegisterWizardWelcome__alert__strong: 'Atención usuarios extranjeros: ',
    RegisterWizardWelcome__alert__description:
      'En el caso de contar con RUT chileno, deberás registrarte como usuario nacional.',
    RegisterWizardWelcome__description__1: 'Al registrarte en Mercado Público',
    RegisterWizardWelcome__description__2: ', ya sea como persona natural o como empresa,',
    RegisterWizardWelcome__description__3:
      'tendrás la posibilidad de convertirte en un proveedor de bienes o servicios del Estado.',
    RegisterWizardWelcome__description__4: 'Podrás',
    RegisterWizardWelcome__description__5:
      'revisar oportunidades de negocio, participar en licitaciones y enviar cotizaciones',
    RegisterWizardWelcome__description__6: 'a todos los organismos públicos del país.',
    RegisterWizardWelcome__question: '¿Cómo quieres registrarte?',
    RegisterWizardWelcome__tab__national: 'USUARIOS NACIONALES',
    RegisterWizardWelcome__tab__foreign: 'USUARIOS EXTRANJEROS',
    RegisterWizardWelcome__selectLanguageButton: 'Continuar en español',
    RegisterWizardWelcome__instructions__1:
      'Si ya estás registrado y quieres asociar una nueva empresa a tu perfil, por favor, haz click ',
    RegisterWizardWelcome__instructions__2: ' y comunícate con nuestra Mesa de Ayuda.',
    RegisterWizardWelcome__instructions__link: 'aquí',
    RegisterWizardForeignPersonalInformation__stepName: 'Información personal',
    RegisterWizardForeignPersonalInformation__title: 'Comencemos',
    RegisterWizardForeignPersonalInformation__description: 'Ingresa tus datos personales',
    RegisterWizardForeignPersonalInformation__fieldInvalidError: 'Este campo tiene un formato incorrecto.',
    RegisterWizardForeignPersonalInformation__fieldMaxLengthError: 'Este campo permite como máximo 15 dígitos.',
    RegisterWizardForeignPersonalInformation__fieldMinLengthError: 'Este campo permite al menos 8 dígitos.',
    RegisterWizardForeignPersonalInformation__fieldOnlyNumbersError: 'Este campo sólo permite números.',
    RegisterWizardForeignPersonalInformation__fieldRequiredError: 'Este campo es obligatorio.',
    RegisterWizardForeignPersonalInformation__identificationNumberAlert__1:
      'Has ingresado un RUT chileno. Para poder continuar debes',
    RegisterWizardForeignPersonalInformation__identificationNumberAlert__2:
      'volver al paso anterior e ingresar como usuario nacional.',
    RegisterWizardForeignPersonalInformation__identificationNumberInputInfo:
      'Sólo puedes ingresar letras, números, guiones y puntos.',
    RegisterWizardForeignPersonalInformation__identificationNumberInputLabel:
      'número de identificación nacional (DNI, SSN, pasaporte, etc.)',
    RegisterWizardForeignPersonalInformation__nameInputLabel: 'Nombres',
    RegisterWizardForeignPersonalInformation__lastNameInputLabel: 'Apellidos',
    RegisterWizardForeignPersonalInformation__phoneInputLabel: 'Teléfono móvil',
    RegisterWizardForeignPersonalInformation__phoneInputPlaceholder: 'Seleccione...',
    RegisterWizardForeignPersonalInformation__genderSelectLabel: 'Sexo',
    RegisterWizardForeignPersonalInformation__genderSelectOption__1: 'Masculino',
    RegisterWizardForeignPersonalInformation__genderSelectOption__2: 'Femenino',
    RegisterWizardForeignPersonalInformation__countrySelectLabel: 'País',
    RegisterWizardForeignPersonalInformation__countrySelectPlaceholder: 'Seleccione...',
    RegisterWizardForeignPersonalInformation__terms__1: 'Declaro haber leído y aceptar los',
    RegisterWizardForeignPersonalInformation__terms__2: 'términos y condiciones',
    RegisterWizardForeignPersonalInformation__back: 'Atrás',
    RegisterWizardForeignPersonalInformation__next: 'Siguiente',
    RegisterWizardEmailVerify__stepName: 'Verificación email',
    RegisterWizardEmailVerify__title: '¡Continuemos!',
    RegisterWizardEmailVerify__description:
      'Enviaremos un código de verificación al email que ingreses a continuación.',
    RegisterWizardEmailVerify__sendingCodeError:
      'En estos momentos no podemos enviarte el código, por favor espera unos minutos e intenta de nuevo.',
    RegisterWizardEmailVerify__invalidCodeError_title: 'Código de verificación incorrecto',
    RegisterWizardEmailVerify__invalidCodeError:
      'El código de verificación es incorrecto, por favor ingrésalo de nuevo.',
    RegisterWizardEmailVerify__fieldFormatError: 'Tu dirección de correo parece estar en un formato incorrecto.',
    RegisterWizardEmailVerify__fieldMaxLengthError:
      'Tu dirección de correo excede el máximo de 80 carácteres permitidos.',
    RegisterWizardEmailVerify__fieldRequiredError: 'Debes ingresar tu dirección de correo.',
    RegisterWizardEmailVerify__emailInputPlaceholder: 'email@ejemplo.com',
    RegisterWizardEmailVerify__emailButtonSend: 'Enviar código',
    RegisterWizardEmailVerify__emailButtonSent: '¡Código enviado!',
    RegisterWizardEmailVerify__codeRemainingTime__1: 'Quedan',
    RegisterWizardEmailVerify__codeRemainingTime__2: 'para ingresar el código que enviamos a tu email.',
    RegisterWizardEmailVerify__codeInputLabel: 'Código de verificación',
    RegisterWizardEmailVerify__backButton: 'Atrás',
    RegisterWizardEmailVerify__nextButton: 'Siguiente',
    RegisterWizardPasswordGeneration__stepName: 'Contraseña',
    RegisterWizardPasswordGeneration__title: 'Ahora crea tu contraseña',
    RegisterWizardPasswordGeneration__description:
      'Para proteger tu cuenta ingresa una contraseña y repítela para confirmarla',
    RegisterWizardPasswordGeneration__headsUp__1:
      'Utiliza una contraseña que sólo tú conozcas y que te sea fácil recordar.',
    RegisterWizardPasswordGeneration__headsUp__2: 'Usa entre 8 y 16 caracteres con al menos 1 letra y 1 número.',
    RegisterWizardPasswordGeneration__fieldFormatError: 'Tu contraseña no cumple con los requisitos mínimos.',
    RegisterWizardPasswordGeneration__fieldMaxLengthError:
      'Tu contraseña excede el máximo de 16 carácteres permitidos.',
    RegisterWizardPasswordGeneration__fieldRequiredError: 'Debes ingresar una contraseña.',
    RegisterWizardPasswordGeneration__fieldRepeatValueError: 'Debes repetir tu contraseña.',
    RegisterWizardPasswordGeneration__fieldSameValueError: 'Esta contraseña no coincide con la anterior.',
    RegisterWizardPasswordGeneration__passwordInputLabel: 'Nueva contraseña',
    RegisterWizardPasswordGeneration__repeatPasswordInputLabel: 'Repite tu contraseña',
    RegisterWizardPasswordGeneration__backButton: 'Atrás',
    RegisterWizardPasswordGeneration__nextButton: 'Siguiente',
    RegisterWizardForeignBusinessInformation__stepName: 'Información empresa',
    RegisterWizardForeignBusinessInformation__title: 'Datos de tu empresa',
    RegisterWizardForeignBusinessInformation__description:
      'Ingresa los datos de la empresa con la que transarás en Mercado Público',
    RegisterWizardForeignBusinessInformation__fieldInvalidError: 'Este campo tiene un formato incorrecto.',
    RegisterWizardForeignBusinessInformation__fieldRequiredError: 'Este campo es obligatorio.',
    RegisterWizardForeignBusinessInformation__legalNameInputLabel: 'Nombre legal',
    RegisterWizardForeignBusinessInformation__nicknameInputLabel: 'Nombre de la marca',
    RegisterWizardForeignBusinessInformation__nicknameTooltip:
      'El nombre de la marca o nombre de fantasía es el nombre bajo el que la empresa opera de cara al público y en los medios de comunicación.',
    RegisterWizardForeignBusinessInformation__dniInputLabel: 'Código único (asignado en el país de origen)',
    RegisterWizardForeignBusinessInformation__dniInputInfo: 'Sólo puedes ingresar letras, números, guiones y puntos.',
    RegisterWizardForeignBusinessInformation__dniInputTooltip__1:
      'El código único es el identificador que cada país asigna a las empresas, usualmente con fines tributarios.',
    RegisterWizardForeignBusinessInformation__dniInputTooltip__2: 'Ej.: DUNS / GLN / LEI / VAT / RUT / etc.',
    RegisterWizardForeignBusinessInformation__fieldDniMaxLengthError: 'Este campo permite como máximo 20 dígitos.',
    RegisterWizardForeignBusinessInformation__typeSelectLabel: 'Tipo de empresa',
    RegisterWizardForeignBusinessInformation__typeSelectOption__21: 'Persona Natural',
    RegisterWizardForeignBusinessInformation__typeSelectOption__22: 'Persona Jurídica',
    RegisterWizardForeignBusinessInformation__sizeSelectLabel: 'Tamaño de la empresa - facturación anual',
    RegisterWizardForeignBusinessInformation__sizeSelectOption__1: 'Sin ventas',
    RegisterWizardForeignBusinessInformation__sizeSelectOption__13: 'Más de 1.000.000 UF',
    RegisterWizardForeignBusinessInformation__sizeSelectInfo__1:
      'UF (Unidad de Fomento) es una unidad de cuenta usada en Chile, reajustable de acuerdo con la inflación.',
    RegisterWizardForeignBusinessInformation__sizeSelectInfo__2: 'Revisa su valor aquí',
    RegisterWizardForeignBusinessInformation__countrySelectLabel: 'País',
    RegisterWizardForeignBusinessInformation__addressInputInfo:
      'Caracteres permitidos: letras (A-Z), números (0-9), espacios y símbolos (.,-º#).',
    RegisterWizardForeignBusinessInformation__addressInputLabel: 'Dirección legal',
    RegisterWizardForeignBusinessInformation__errorBusinessExists_modalTitle: 'Proveedor ya existe en Mercado Público',
    RegisterWizardForeignBusinessInformation__errorBusinessExists_modalText_1:
      'Para asociar esta empresa a tu perfil deberás contactar al administrador vigente para que él pueda crear tu cuenta desde su escritorio.',
    RegisterWizardForeignBusinessInformation__errorBusinessExists_modalText_2:
      'Si tienes acceso a una cuenta de usuario existente puedes ingresar o recuperar tu contraseña volviendo al inicio de sesión.',
    RegisterWizardForeignBusinessInformation__errorBusinessExists_actionButton: 'Ir al inicio de sesión',
    RegisterWizardForeignBusinessInformation__errorBusinessExists_instructions_1:
      'Si el administrador anterior ya no está disponible o no trabaja en la empresa, ',
    RegisterWizardForeignBusinessInformation__errorBusinessExists_instructions_2:
      'puedes identificarte como el nuevo administrador comunicándote con nuestra mesa de ayuda',
    RegisterWizardForeignBusinessInformation__errorBusinessNational_modalTitle: 'Proveedor nacional detectado',
    RegisterWizardForeignBusinessInformation__errorBusinessNational_modalText_1:
      'Hemos detectado que el número de documento asociado a tu cuenta corresponde a un proveedor nacional.',
    RegisterWizardForeignBusinessInformation__errorBusinessNational_modalText_2:
      'Para continuar, haz clic en "Registrar proveedor nacional" y completa tu registro',
    RegisterWizardForeignBusinessInformation__errorBusinessNational_actionButton: 'Registrar proveedor nacional',
    RegisterWizardForeignBusinessInformation__errorBusinessNational_instructions_1: '',
    RegisterWizardForeignBusinessInformation__errorBusinessNational_instructions_2: '',
    RegisterWizardForeignBusinessInformation__backButton: 'Atrás',
    RegisterWizardForeignBusinessInformation__nextButton: 'Siguiente',
    RegisterWizardComplete__stepName: '¡Listo!',
    RegisterWizardComplete__title: 'Registro completado',
    RegisterWizardComplete__description:
      'Ya te encuentras registrado como usuario y has asociado exitosamente tu empresa a tu perfil. El siguiente paso para participar en las oportunidades de negocio del Estado de Chile es iniciar sesión y validar la información de tu empresa.',
    RegisterWizardComplete__instructions__1: 'Tu nuevo nombre de usuario es:',
    RegisterWizardComplete__instructions__2:
      'Este nombre de usuario y tu contraseña serán tus credenciales para iniciar sesión en Mercado Público. Se ha enviado una copia de esta información a ',
    RegisterWizardComplete__desktopButton: 'Ir a Mercado Público',
    RegisterWizardComplete__affidavit_subtitle: 'Pago de Acreditación (opcional)',
    RegisterWizardComplete__affidavit_description:
      'El pago de la tarifa te permitirá acreditar en línea la situación de la empresa. No es obligatorio pero ten presente que los organismos públicos pueden solicitar en las Bases de Licitación que los proveedores estén acreditados al momento de ser contratados.',
    RegisterWizardComplete__affidavitLink: 'Ver más detalles'
  },
  en: {
    WizardLayout__step: 'Step',
    WizardLayout__stepOf: 'of',
    RegisterWizardWelcome__title: 'Welcome to MercadoPúblico',
    RegisterWizardWelcome__alert__strong: 'Attention foreign user: ',
    RegisterWizardWelcome__alert__description:
      'In the case of having a Chilean RUT, you must register as a national user.',
    RegisterWizardWelcome__description__1: 'By registering in MercadoPúblico',
    RegisterWizardWelcome__description__2: ', either as a natural person or as a company,',
    RegisterWizardWelcome__description__3:
      'you will have the possibility to become a supplier of goods or services of the State.',
    RegisterWizardWelcome__description__4: 'You will be able',
    RegisterWizardWelcome__description__5: 'to review business opportunities, participate in bidding processes',
    RegisterWizardWelcome__description__6: 'and send quotes to all public bodies in the country.',
    RegisterWizardWelcome__question: 'How do you want to register?',
    RegisterWizardWelcome__tab__national: 'NATIONAL USERS',
    RegisterWizardWelcome__tab__foreign: 'FOREIGN USERS',
    RegisterWizardWelcome__selectLanguageButton: 'Continue in English',
    RegisterWizardWelcome__instructions__1:
      'If you are already registered and want to associate a new company to your profile, please, click ',
    RegisterWizardWelcome__instructions__2: ' and contact our Help Desk.',
    RegisterWizardWelcome__instructions__link: 'here',
    RegisterWizardForeignPersonalInformation__stepName: 'Personal information',
    RegisterWizardForeignPersonalInformation__title: 'Let’s get started',
    RegisterWizardForeignPersonalInformation__description: 'Enter your personal details',
    RegisterWizardForeignPersonalInformation__fieldInvalidError: 'This field has an invalid format.',
    RegisterWizardForeignPersonalInformation__fieldMaxLengthError: 'This field allows 15 digits at most.',
    RegisterWizardForeignPersonalInformation__fieldMinLengthError: '8 digits minimum required for this field.',
    RegisterWizardForeignPersonalInformation__fieldOnlyNumbersError: 'This field only allows numbers.',
    RegisterWizardForeignPersonalInformation__fieldRequiredError: 'This field is required.',
    RegisterWizardForeignPersonalInformation__identificationNumberAlert__1:
      'You have entered a Chilean ID (RUT). In order to continue you must',
    RegisterWizardForeignPersonalInformation__identificationNumberAlert__2:
      'go back to the previous step and sign up as a national user.',
    RegisterWizardForeignPersonalInformation__identificationNumberInputInfo:
      'You can only enter letters, numbers, hyphens, and periods.',
    RegisterWizardForeignPersonalInformation__identificationNumberInputLabel:
      'National identification number (DNI, SSN, passport, etc.)',
    RegisterWizardForeignPersonalInformation__nameInputLabel: 'First name',
    RegisterWizardForeignPersonalInformation__lastNameInputLabel: 'Last name',
    RegisterWizardForeignPersonalInformation__phoneInputLabel: 'Phone number',
    RegisterWizardForeignPersonalInformation__phoneInputPlaceholder: 'Select...',
    RegisterWizardForeignPersonalInformation__genderSelectLabel: 'Gender',
    RegisterWizardForeignPersonalInformation__genderSelectOption__1: 'Male',
    RegisterWizardForeignPersonalInformation__genderSelectOption__2: 'Female',
    RegisterWizardForeignPersonalInformation__countrySelectLabel: 'Country',
    RegisterWizardForeignPersonalInformation__countrySelectPlaceholder: 'Select...',
    RegisterWizardForeignPersonalInformation__terms__1: 'I declare to have read and accept the',
    RegisterWizardForeignPersonalInformation__terms__2: 'terms and conditions',
    RegisterWizardForeignPersonalInformation__back: 'Back',
    RegisterWizardForeignPersonalInformation__next: 'Next',
    RegisterWizardEmailVerify__stepName: 'Email verification',
    RegisterWizardEmailVerify__title: "Let's keep going",
    RegisterWizardEmailVerify__description: 'We will send a verification code to the email you enter below.',
    RegisterWizardEmailVerify__sendingCodeError_title: 'Unable to send you the code.',
    RegisterWizardEmailVerify__sendingCodeError:
      'We are currently unable to send you the code, please wait a few minutes and try again.',
    RegisterWizardEmailVerify__invalidCodeError_title: 'Incorrect verification code',
    RegisterWizardEmailVerify__invalidCodeError: 'The verification code is incorrect, please enter it again.',
    RegisterWizardEmailVerify__fieldFormatError: 'Your email address seems to be in the wrong format.',
    RegisterWizardEmailVerify__fieldMaxLengthError: 'Your email address exceeds the maximum of 80 characters allowed.',
    RegisterWizardEmailVerify__fieldRequiredError: 'You must enter your email address.',
    RegisterWizardEmailVerify__emailInputPlaceholder: 'email@example.com',
    RegisterWizardEmailVerify__emailButtonSend: 'Send code',
    RegisterWizardEmailVerify__emailButtonSent: 'Code sent!',
    RegisterWizardEmailVerify__codeRemainingTime__1: 'You have',
    RegisterWizardEmailVerify__codeRemainingTime__2: 'to enter the code that we sent to your email.',
    RegisterWizardEmailVerify__codeInputLabel: 'Verification code',
    RegisterWizardEmailVerify__backButton: 'Back',
    RegisterWizardEmailVerify__nextButton: 'Next',
    RegisterWizardPasswordGeneration__stepName: 'Password',
    RegisterWizardPasswordGeneration__title: "Now let's create your password",
    RegisterWizardPasswordGeneration__description:
      'To protect your account, enter a password and repeat it to confirm it',
    RegisterWizardPasswordGeneration__headsUp__1:
      'Use a password that only you know and that is easy for you to remember.',
    RegisterWizardPasswordGeneration__headsUp__2:
      'Use between 8 and 16 characters with at least 1 letter and 1 number.',
    RegisterWizardPasswordGeneration__fieldFormatError: 'Your password does not meet the minimum requirements.',
    RegisterWizardPasswordGeneration__fieldMaxLengthError:
      'Your password exceeds the maximum of 16 characters allowed.',
    RegisterWizardPasswordGeneration__fieldRequiredError: 'You must enter a password.',
    RegisterWizardPasswordGeneration__fieldRepeatValueError: 'You must repeat your password.',
    RegisterWizardPasswordGeneration__fieldSameValueError: 'This password does not match the previous one.',
    RegisterWizardPasswordGeneration__passwordInputLabel: 'New password',
    RegisterWizardPasswordGeneration__repeatPasswordInputLabel: 'Repeat your password',
    RegisterWizardPasswordGeneration__backButton: 'Back',
    RegisterWizardPasswordGeneration__nextButton: 'Next',
    RegisterWizardForeignBusinessInformation__stepName: 'Company details',
    RegisterWizardForeignBusinessInformation__title: 'Company details',
    RegisterWizardForeignBusinessInformation__description:
      'Enter the information of the company with which you will trade in Mercado Público',
    RegisterWizardForeignBusinessInformation__fieldInvalidError: 'This field has an invalid format.',
    RegisterWizardForeignBusinessInformation__fieldRequiredError: 'This field is required.',
    RegisterWizardForeignBusinessInformation__legalNameInputLabel: 'Legal name',
    RegisterWizardForeignBusinessInformation__nicknameInputLabel: 'Brand name',
    RegisterWizardForeignBusinessInformation__nicknameTooltip:
      'The brand name or trade name is the name under which the company operates in the public eye and in the media.',
    RegisterWizardForeignBusinessInformation__dniInputLabel: 'Unique ID (assigned in the country of origin)',
    RegisterWizardForeignBusinessInformation__dniInputInfo:
      'You can only enter letters, numbers, hyphens, and periods.',
    RegisterWizardForeignBusinessInformation__dniInputTooltip__1:
      'The unique ID is the identifier that each country assigns to companies, usually for tax purposes.',
    RegisterWizardForeignBusinessInformation__dniInputTooltip__2: 'Ex: DUNS / GLN / LEI / VAT / RUT / etc.',
    RegisterWizardForeignBusinessInformation__fieldDniMaxLengthError: 'This field allows 20 digits at most.',
    RegisterWizardForeignBusinessInformation__typeSelectLabel: 'Company type',
    RegisterWizardForeignBusinessInformation__typeSelectOption__21: 'Natural Entity',
    RegisterWizardForeignBusinessInformation__typeSelectOption__22: 'Legal Entity',
    RegisterWizardForeignBusinessInformation__sizeSelectLabel: 'Company size - annual turnover',
    RegisterWizardForeignBusinessInformation__sizeSelectOption__1: 'No Sales',
    RegisterWizardForeignBusinessInformation__sizeSelectOption__13: 'More than 1.000.000 UF',
    RegisterWizardForeignBusinessInformation__sizeSelectInfo__1:
      'UF (Unidad de Fomento) is a unit of account used in Chile, readjusted according to inflation.',
    RegisterWizardForeignBusinessInformation__sizeSelectInfo__2: 'Check its value here',
    RegisterWizardForeignBusinessInformation__countrySelectLabel: 'Country',
    RegisterWizardForeignBusinessInformation__addressInputInfo:
      'Allowed characters: letters (A-Z), numbers (0-9), spaces, and symbols (.,-º#).',
    RegisterWizardForeignBusinessInformation__addressInputLabel: 'Legal address',
    RegisterWizardForeignBusinessInformation__errorModalTitle: 'already exists in Mercado Público',
    RegisterWizardForeignBusinessInformation__errorModalText__1:
      'To associate this company with your profile you must contact the current administrator so that he can create your account from his desktop.',
    RegisterWizardForeignBusinessInformation__errorModalText__2:
      'If you have access to an existing user account, you can enter or retrieve your password by returning to the login.',
    RegisterWizardForeignBusinessInformation__errorModalButton: 'Go to login',
    RegisterWizardForeignBusinessInformation__errorModalInstructions__1:
      'If the previous administrator is no longer available or does not work for the company, you can ',
    RegisterWizardForeignBusinessInformation__errorModalInstructions__2:
      'identify yourself as the new administrator by contacting our help desk',
    RegisterWizardForeignBusinessInformation__backButton: 'Back',
    RegisterWizardForeignBusinessInformation__nextButton: 'Next',
    RegisterWizardComplete__stepName: 'Finish!',
    RegisterWizardComplete__title: 'Registration completed',
    RegisterWizardComplete__description:
      "You are already registered as a user and you have successfully associated your company to your profile. The next step to participate in the business opportunities of the State of Chile is to log in and validate your company's information.",
    RegisterWizardComplete__instructions__1: 'Your new user name is:',
    RegisterWizardComplete__instructions__2:
      'This username and your password will be your credentials to log in to MercadoPúblico. A copy of this information has been sent to ',
    RegisterWizardComplete__desktopButton: 'Continue to Mercado Público',
    RegisterWizardComplete__affidavit_subtitle: 'Accreditation payment (optional)',
    RegisterWizardComplete__affidavit_description:
      'The payment of the fee will allow you to prove the situation of the company online. It is not mandatory, but it is present that public bodies may request in the Bidding Bases that suppliers be accredited at the time of being hired.',
    RegisterWizardComplete__affidavitLink: 'See more details'
  }
}
